const translations = {
  // Navbar
  "nav.home": "Home",
  "nav.products": "Products",
  "nav.features": "Features",
  "nav.pricing": "Pricing",
  "nav.orderNow": "Order Now",
  "nav.contact": "Contact",
  
  // Hero
  "hero.title": "Experience Coziness",
  "hero.titleLine2": "in Every Practice",
  "hero.subtitle": "Premium Pilates and yoga towels with smart silicone grips to keep you steady, comfortable, and clean",
  "hero.orderNow": "See products",
  "hero.discoverMore": "discover more",
  
  // Products
  "products.title": "MYSA Products",
  "products.subtitle": "Designed to feel good, stay clean, and keep you steady — in colors you'll love.",
  "products.brown": "Brown",
  "products.crimson": "Crimson Red",
  "products.earthBrown": "Earth Brown",
  "products.multi": "Multi",
  "products.pilatesReformerBrown": "Pilates Reformer Set - Brown",
  "products.pilatesReformerBrownDesc": "Premium set with innovative Anti slip technology that adheres perfectly to your Pilates bed. Anti bacterial materials with superior grip and hygiene.",
  "products.pilatesReformerCrimson": "Pilates Reformer Set - Crimson",
  "products.pilatesReformerCrimsonDesc": "Luxuriously soft and absorbent Pilates towel in vibrant red. Features our signature Silicone technology for non-slip performance during hot sessions.",
  "products.yogaTowel": "Yoga Towel - Earth Brown",
  "products.yogaTowelDesc": "Warm earth-toned yoga towel that combines style with functionality. Hygienic, quick-drying, and environmentally conscious design.",
  "products.completeSet": "Pilates Reformer Seti",
  "products.completeSetDesc": "Everything you need for your practice. Includes one Pilates Reformer towel, a light face towel and a duffle bag. Perfect for the dedicated practitioner.",
  
  // Features
  "features.title": "Why Choose MYSA",
  "features.subtitle": "Every detail is crafted with intention. Discover what makes our products the perfect companion for your wellness journey.",
  "features.hygiene": "Superior Hygiene",
  "features.hygieneDesc": "Our products are designed with hygiene as a top priority. Easy to clean, quick-drying materials that resist bacteria and odor, keeping your practice fresh and healthy.",
  "features.antiSlip": "Innovative Anti-Slip Technology",
  "features.antiSlipDesc": "Unique adhesive dot pattern that grips your Pilates bed perfectly. No slipping, no sliding—just pure focus on your practice with complete stability and confidence.",
  "features.eco": "Eco-Conscious Materials",
  "features.ecoDesc": "Sustainably sourced, environmentally friendly materials that are kind to the planet. We believe wellness extends beyond personal health to the health of our Earth.",
  "features.colors": "Vibrant Colors",
  "features.colorsDesc": "Beautiful, rich colors that inspire joy and energy. From deep crimson reds to warm earth browns, our products bring life and personality to your practice space.",
  "features.comfort": "Ultimate Comfort",
  "features.comfortDesc": "MYSA means coziness, and we deliver on that promise. Soft, cushioned materials that support your body while providing the perfect balance of grip and comfort.",
  "features.quality": "Premium Quality",
  "features.qualityDesc": "Built to last through countless sessions. High-quality construction and materials ensure your investment continues to perform beautifully for years to come.",
  "features.techTitle": "The Technology Behind the Grip",
  "features.techDesc": "Our silicone stop technology isn't just about grip—it's about helping you feel grounded in your practice. Each dot is carefully designed to stick securely to Pilates beds while still feeling soft and comfortable on your skin. The result? A mat that stays put so you don't have to think about it. No slipping, no constant readjusting—just smooth movement, steady breath, and a distraction-free flow.",
  
  // Pricing
  "pricing.label": "Mindful Investment",
  "pricing.title": "Choose Your Practice Essentials",
  "pricing.subtitle": "Quality pieces crafted for your wellness journey",
  "pricing.yogaTowel": "Yoga Towel",
  "pricing.pilatesSet": "Pilates Reformer Set",
  "pricing.wellnessSet": "Complete Wellness Set",
  "pricing.favorite": "Favorite",
  "pricing.select": "Select",
  "pricing.freeShipping": "Free Shipping",
  "pricing.freeShippingDesc": "Orders over 1000₺",
  "pricing.ecoFriendly": "Eco-Friendly",
  "pricing.ecoFriendlyDesc": "Sustainable materials",
  "pricing.madeWithCare": "Made with Care",
  "pricing.madeWithCareDesc": "30-day guarantee",
  "pricing.saveBundle": "Save 200TL",
  "pricing.feature1": "Premium microfiber material",
  "pricing.feature2": "Smart silicone grip dots",
  "pricing.feature3": "Quick-dry technology",
  "pricing.feature4": "Machine washable",
  "pricing.feature5": "Available in multiple colors",
  "pricing.setFeature1": "Full reformer coverage",
  "pricing.setFeature2": "Non-slip material",
  "pricing.setFeature3": "Moisture-wicking fabric",
  "pricing.setFeature4": "Available in Brown & Crimson",
  "pricing.setFeature5": "Professional-grade quality",
  "pricing.wellnessFeature1": "1 Pilates Reformer Set",
  "pricing.wellnessFeature2": "1 Yoga Towel in your choice",
  "pricing.wellnessFeature3": "1 Face towel included",
  "pricing.wellnessFeature4": "Premium duffle bag",
  "pricing.wellnessFeature5": "Save ₺200 with bundle",
  "pricing.buyOnTrendyol": "Buy on Trendyol",
  
  // CTA
  "cta.title": "Ready to Transform",
  "cta.titleLine2": "Your Practice?",
  "cta.subtitle": "Join thousands of practitioners who have discovered the perfect blend of comfort, performance, and sustainability with MYSA products.",
  "cta.button": "Start Your Journey Today",
  "cta.practitioners": "Happy Practitioners",
  "cta.ecoFriendly": "Eco-Friendly",
  "cta.rating": "Average Rating",
  
  // Order Form
  "order.title": "Place Your Order",
  "order.subtitle": "Fill out the form below and we'll get back to you shortly to confirm your order.",
  "order.fullName": "Full Name",
  "order.email": "Email Address",
  "order.phone": "Phone Number",
  "order.selectProduct": "Select Product",
  "order.clickToSelect": "Click on a product to select it",
  "order.quantity": "Quantity",
  "order.colorPreference": "Color Preference",
  "order.selectColor": "Select color",
  "order.crimsonRed": "Crimson Red",
  "order.earthBrown": "Earth Brown",
  "order.noPreference": "No Preference",
  "order.streetAddress": "Street Address",
  "order.city": "City",
  "order.state": "State/Province",
  "order.zipCode": "Zip/Postal Code",
  "order.additionalNotes": "Additional Notes",
  "order.notesPlaceholder": "Any special requests or questions? (Max 500 characters)",
  "order.characters": "characters",
  "order.success": "Order Submitted Successfully!",
  "order.successDesc": "We'll contact you shortly to confirm your order.",
  "order.error": "Submission Failed",
  "order.errorDesc": "Please try again or contact us directly.",
  "order.submit": "Submit Order",
  "order.submitting": "Submitting...",
  "order.terms": "By submitting this form, you agree to our terms and conditions. We'll contact you to confirm your order and arrange payment.",
  "order.required": "Please fill in all required fields",
  
  // Footer
  "footer.description": "Premium Pilates and Yoga products designed with care for your wellness journey. Eco-conscious, vibrant, and built to last.",
  "footer.quickLinks": "Quick Links",
  "footer.contact": "Contact",
  "footer.followUs": "Follow Us",
  "footer.community": "Join our community and stay updated with wellness tips and exclusive offers.",
  "footer.rights": "© 2024 MYSA. All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
  "footer.alsoAvailable": "Also available on",
  "footer.shopTrendyol": "Shop on Trendyol",

  // Contact
  "contact.label": "Get In Touch",
  "contact.title": "We\u0027re Here to Help",
  "contact.subtitle": "Have a question about our products, your order, or just want to say hello? We\u0027d love to hear from you.",
  "contact.emailUs": "Email Us",
  "contact.emailResponse": "We reply within 24 hours",
  "contact.callUs": "Call Us",
  "contact.callHours": "Mon\u2013Fri, 9AM\u20136PM",
  "contact.whatsapp": "WhatsApp",
  "contact.whatsappChat": "Start a chat",
  "contact.whatsappResponse": "Fastest way to reach us",
  "contact.location": "Location",
  "contact.followUs": "Follow Us",
  "contact.formTitle": "Send Us a Message",
  "contact.formSubtitle": "We typically respond within a few hours",
  "contact.nameLabel": "Full Name",
  "contact.namePlaceholder": "Your name",
  "contact.emailLabel": "Email Address",
  "contact.emailPlaceholder": "you@example.com",
  "contact.subjectLabel": "How can we help?",
  "contact.subjectPlaceholder": "Select a topic",
  "contact.subjectProduct": "Product Questions",
  "contact.subjectOrder": "Order Support",
  "contact.subjectShipping": "Shipping & Delivery",
  "contact.subjectReturns": "Returns & Exchanges",
  "contact.subjectOther": "Other",
  "contact.messageLabel": "Your Message",
  "contact.messagePlaceholder": "Tell us how we can help you...",
  "contact.sendButton": "Send Message",
  "contact.sending": "Sending...",
  "contact.privacy": "Your information is secure and private",
  "contact.successTitle": "Message Sent!",
  "contact.successDesc": "We\u0027ll get back to you as soon as possible.",
  "contact.errorTitle": "Something went wrong",
  "contact.errorDesc": "Please try again or email us directly.",

  // Gallery
  "gallery.label": "Gallery",
  "gallery.title": "See MYSA in Your Practice",
  "gallery.subtitle": "Real moments from our community showing how MYSA products enhance every session.",
  "gallery.filterAll": "All",
  "gallery.filterProducts": "Products",
  "gallery.filterPractice": "In Practice",
  "gallery.filterDetails": "Up Close",
  "gallery.image1Alt": "MYSA pilates reformer towel in earth brown on reformer machine",
  "gallery.image1Caption": "Premium grip meets elegant design on every reformer",
  "gallery.image2Alt": "Close up of silicone anti-slip grip dots",
  "gallery.image2Caption": "Innovative silicone technology for unmatched stability",
  "gallery.image3Alt": "Pilates practice with MYSA towel",
  "gallery.image3Caption": "Steady flow and full focus in every session",
  "gallery.image4Alt": "Complete MYSA wellness set flat lay",
  "gallery.image4Caption": "Everything you need — towel, mat, bag, all in one set",
  "gallery.image5Alt": "Yoga session with MYSA towel",
  "gallery.image5Caption": "Comfort and calm in every pose",
  "gallery.image6Alt": "MYSA yoga towel rolled with accessories",
  "gallery.image6Caption": "Ready for your next session, wherever you go",
  "gallery.image7Alt": "Grip detail on pilates reformer",
  "gallery.image7Caption": "Anti-slip dots that keep you grounded",
  "gallery.image8Alt": "Modern pilates studio with MYSA towels",
  "gallery.image8Caption": "Trusted by studios for premium hygiene and comfort",
  "gallery.image9Alt": "Yoga practice with MYSA crimson towel in child pose",
  "gallery.image9Caption": "Deep stretch and total comfort on every surface",
  "gallery.followInstagram": "Follow Us on Instagram"
};

export default translations;
